export default __webpack_public_path__ + "static/email-ac8e6873d1886b46fb1767fb6d36b256.jpg";